let bodyScrollTop = 0;
let activeModal = null;

function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function onModalKeyup(event) {
    if (event.key === 'Escape') {
        hideModal();
    }
}

function onModalClick(event) {
    const modal = activeModal;
    if (!modal) {
        return;
    }

    const closeButton = event.target.closest('.close, .close-modal, [data-dismiss="modal"]');
    if (event.target === modal || (closeButton && modal.contains(closeButton))) {
        event.preventDefault();
        hideModal();
    }
}

function findModal() {
    return document.querySelector('#snippet--modal .modal')
        ?? Array.from(document.querySelectorAll('.modal.open')).at(-1)
        ?? Array.from(document.querySelectorAll('.modal')).at(-1)
        ?? null;
}

function disableBodyScroll() {
    bodyScrollTop = window.scrollY;
    document.documentElement.classList.add('disable-scroll');
    document.body.classList.add('disable-scroll');

    if (isTouchDevice()) {
        document.body.style.position = 'relative';
        document.body.style.top = `-${bodyScrollTop}px`;
        document.body.style.height = `${window.innerHeight + bodyScrollTop}px`;
        window.scrollTo(0, 0);
    }
}

function enableBodyScroll() {
    document.documentElement.classList.remove('disable-scroll');
    document.body.classList.remove('disable-scroll');

    if (isTouchDevice()) {
        document.body.removeAttribute('style');
        window.scrollTo(0, bodyScrollTop);
    }
}

export function showModal() {
    const modal = findModal();
    if (!modal) {
        return;
    }

    activeModal = modal;
    modal.classList.remove('close');
    modal.classList.add('open');
    document.removeEventListener('keyup', onModalKeyup);
    document.removeEventListener('click', onModalClick);
    document.addEventListener('keyup', onModalKeyup);
    document.addEventListener('click', onModalClick);
    disableBodyScroll();
}

export function hideModal() {
    const modal = activeModal ?? findModal();
    document.removeEventListener('keyup', onModalKeyup);
    document.removeEventListener('click', onModalClick);
    enableBodyScroll();
    activeModal = null;

    if (!modal) {
        return;
    }

    modal.classList.remove('open');
    modal.classList.add('close');
    window.setTimeout(() => modal.classList.remove('close'), 500);

    const returnUrl = modal.dataset.returnUrl;
    if (returnUrl && window.location.href !== new URL(returnUrl, window.location.href).href) {
        window.history.replaceState(window.history.state, '', returnUrl);
    }
}

export function removeModal() {
    document.removeEventListener('keyup', onModalKeyup);
    document.removeEventListener('click', onModalClick);
    enableBodyScroll();
    const modal = activeModal ?? findModal();
    activeModal = null;
    modal?.remove();
}
